import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPC_CHANNEL } from '../../_offline/electron.constants';
import { SubjectAttributesSchema } from '../../_offline/models/subject-attributes.schema';
import { DatabaseBaseService } from '../base/database-base.service';
import { LoginUserOfflineService } from '../offline/login-user-offline.service';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class SubjectAttributesDbService extends DatabaseBaseService {

  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService) {
    super(electronService, loginUserService);
  }

  getAll(): Observable<SubjectAttributesSchema[]>  {
    return this.ipcSendSync(IPC_CHANNEL.SUBJECT_ATTRIBUTES.GET_ALL);
  }

  putAll(subjectAttributes: SubjectAttributesSchema[]): Observable<SubjectAttributesSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.SUBJECT_ATTRIBUTES.PUT_ALL, subjectAttributes);
  }

  getOne(id: string): Observable<SubjectAttributesSchema>  {
    return this.ipcSendSync(IPC_CHANNEL.SUBJECT_ATTRIBUTES.GET_ONE, this.tenantId, id);
  }
}
